import React from "react";

import { Button } from "src/app/components/Button/Button";
import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";
import NoResults from "src/app/components/NoResultsScreen/NoResultsScreen";
import { ReactComponent as PlusIcon } from "src/images/plus-transparent.svg";
import { ReactComponent as EditIcon } from "src/images/edit.svg";
import emptyInsightsDashboardPlaceholder from "src/images/empty-insights-dashboard.svg";
import { setSearchParam } from "src/utils/methods";
import { useHistory } from "react-router";
import {
  SETUP_MODE_QUERY_PARAM_KEY,
  SetupModes,
} from "../../panes/InsightsDashboardSetupPane/InsightsDashboardSetupPane";

export type IDNoResultsVariant = "noDashboard" | "setup";

interface IDNoResultsProps {
  variant: IDNoResultsVariant;
}

export const IDNoResults = ({ variant }: IDNoResultsProps) => {
  const history = useHistory();

  const openSetupPane = (mode: SetupModes) => {
    setSearchParam({
      history,
      key: SETUP_MODE_QUERY_PARAM_KEY,
      value: mode,
    });
  };

  if (variant === "setup") {
    return (
      <NoResults
        title={
          <IDHFormattedMessage
            id="ws_no_publications_match_this_setup"
            defaultMessage="No publications match this setup"
          />
        }
        subtitle={
          <IDHFormattedMessage
            id="ws_no_publications_match_this_setup_subtitle_v2"
            defaultMessage='Try a longer time range, add more platforms or countries, or check the spelling of your hashtags and mentions. If "Combine hashtags and mentions" is on, turn it off to see posts that match either one.'
          />
        }
        bottomContent={
          <Button
            size="medium"
            variant="blue"
            onClick={() => openSetupPane(SetupModes.Edit)}
          >
            <EditIcon />
            <IDHFormattedMessage
              id="ws_edit_filters"
              defaultMessage="Edit filters"
            />
          </Button>
        }
        imgUrl={emptyInsightsDashboardPlaceholder}
      />
    );
  }

  return (
    <NoResults
      title={
        <IDHFormattedMessage
          id="ws_create_your_first_dashboard"
          defaultMessage="Create your first dashboard"
        />
      }
      subtitle={
        <IDHFormattedMessage
          id="ws_create_your_first_dashboard_subtitle"
          defaultMessage="Pick the platforms, countries, hashtags and mentions you want to track. You can change the filters any time."
        />
      }
      bottomContent={
        <Button
          size="medium"
          variant="blue"
          onClick={() => openSetupPane(SetupModes.Create)}
        >
          <PlusIcon />
          <IDHFormattedMessage
            id="ws_create_dashboard"
            defaultMessage="Create dashboard"
          />
        </Button>
      }
      imgUrl={emptyInsightsDashboardPlaceholder}
    />
  );
};
